import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PaperClipOutlined, EyeOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
import { PhotoViewerModal } from './photo-viewer-modal.component'

const translationPath = 'jobs.job.info.data-validation'

const DetailsSection = ({ details }) => {
  const { t } = useTranslation()

  return (
    <section className='validation-detail'>
      <ul>
        <li>
          <p>{t(`${translationPath}.who-receives`)}:</p> <p>{details.cash_receiver}</p>
        </li>
        <li>
          <p>{t(`${translationPath}.contact-phone`)}:</p> <p>{details.phone_number}</p>
        </li>
        <li>
          <p>{t(`${translationPath}.comment`)}:</p> <p>{details.comment}</p>
        </li>
      </ul>
    </section>
  )
}

const ValidationCard = ({ title, photo, pickupCode, detail, photoViewerTitle, job, photoName, imageType }) => {
  const { t } = useTranslation()
  const cardStyle = !detail ? 'fixed-height' : ''

  const [showDetail, setShowDetail] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)

  const photoLabel = photo ? (
    <p className='card-photoLabel' onClick={() => setModalOpen(true)}>
      {photoName}
      <EyeOutlined />
    </p>
  ) : (
    <p>{t(`${translationPath}.no-photo`)}</p>
  )

  return (
    <>
      <article className={`validation-card ${cardStyle}`}>
        <h3>{title}</h3>
        {pickupCode ? (
          <div>{pickupCode}</div>
        ) : (
          <div>
            <span>
              <PaperClipOutlined />
              {photoLabel}
            </span>
            {detail && (
              <span className='delivery-detail' onClick={() => setShowDetail(!showDetail)}>
                {t(`${translationPath}.see-detail`)} {showDetail ? <UpOutlined /> : <DownOutlined />}
              </span>
            )}
          </div>
        )}
        {detail && showDetail && <DetailsSection details={detail} />}
      </article>
      {photo && isModalOpen && (
        <PhotoViewerModal
          title={photoViewerTitle}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          job={job}
          photo={photo}
          imageType={imageType}
        />
      )}
    </>
  )
}

export { ValidationCard }
